import { render, staticRenderFns } from "./purchase-export.vue?vue&type=template&id=8e1a1676"
import script from "./purchase-export.vue?vue&type=script&lang=js"
export * from "./purchase-export.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports